export const locale = {
    lang: 'de',
    data: {
      'NOMBREIDIOMAS': {
        'es': 'Spanish',
        'en': 'English',
        'pt': 'Portuguese',
        'zh1': 'Traditional Chinese',
        'zh2': 'Simplified Chinese',
        'tr': 'Turkish',
        'vi': 'Vietnamese',
        'ja': 'Japanese',
        'my': 'Malay',
        'ro': 'Romanian',
        'ru': 'Russian',
        'fr': 'French',
        'de': 'German',
        'it': 'Italian',
        'nl':'Dutch',
        'ms': 'Malaiisch',
        'hi': 'Hindi',
        'id': 'Indonesisch',
        'ua': 'ukrainisch',
        'ge': 'georgisch',
        'uz': 'Usbekisch',
        'az': 'Aserbaidschan',
        'kk': 'Kasachstan',
        'hr': 'kroatisch',
        'ar': 'Arabisch',
        'mk': 'mazedonisch',
        'lv': 'Lettisch',
        'pr': 'Portuguese (Portugal)',
        'th': 'Thailändisch',
      }
    }
};
